import { initialAppShellState } from '@/states/repApp';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const appShellSlice = createSlice({
  name: 'appShell',
  initialState: initialAppShellState,
  reducers: {
    setAppLoading(state, action: PayloadAction<{ value: boolean }>) {
      state.isAppLoading = action.payload.value;
    },
    showAppLoading(state) {
      state.isAppLoading = true;
    },
    hideAppLoading(state) {
      state.isAppLoading = false;
    },
    setAppNotice(state, { payload }) {
      const incomingRedirect = payload?.redirectTo ?? null;
      const existingRedirect = state.appNotice.redirectTo || null;
      if (existingRedirect && !incomingRedirect) return;

      state.appNotice.open = payload?.open ?? Boolean(payload?.message);
      state.appNotice.title = payload?.title || '';
      state.appNotice.message = payload?.message || '';
      state.appNotice.status = payload?.status ?? null;
      state.appNotice.details = payload?.details || '';
      state.appNotice.messageFormatted = payload?.messageFormatted || '';
      state.appNotice.action = payload?.action || '';
      state.appNotice.endpointName = payload?.endpointName || '';
      state.appNotice.errors = payload?.errors || payload?.validationErrors || {};
      state.appNotice.validationErrors = payload?.validationErrors || payload?.errors || {};
      state.appNotice.variant = payload?.variant || 'warning';
      state.appNotice.redirectTo = incomingRedirect;
    },
    setIdleTimer(state, { payload }) {
      state.idleTimer.showModal = payload.showModal || false;
      state.idleTimer.action = payload.action || '';
    },
    setLanguage(state, action: PayloadAction<{ value: string }>) {
      state.language = action.payload.value;
    },
    resetAppShell(state) {
      const currentLanguage = state.language;
      const newState = { ...initialAppShellState };
      newState.language = currentLanguage;
      return newState;
    },
  },
});

export const {
  setAppLoading,
  showAppLoading,
  hideAppLoading,
  setAppNotice,
  setIdleTimer,
  setLanguage,
  resetAppShell,
} = appShellSlice.actions;
export default appShellSlice.reducer;
